import { Box } from '@mui/material';
import { CustomTable } from '../../common/CustomTable';

interface VoicemailAgent {
  agentId: number;
  agentName?: string;
  count: number;
  inboundCount: number;
  outboundCount: number;
  averageDuration: number;
}

interface VoicemailsAgentsTabProps {
  agents: VoicemailAgent[];
  comparison?: VoicemailAgent[];
  formatWithComparisonTwoRows: (value: string | number, prevValue?: string | number) => JSX.Element;
  formatDuration: (seconds: number) => string;
  findAgentComparison: <T extends { agentId: number }>(agentId: number, comparisonAgents?: T[]) => T | undefined;
}

export const VoicemailsAgentsTab = ({
  agents,
  comparison,
  formatWithComparisonTwoRows,
  formatDuration,
  findAgentComparison,
}: VoicemailsAgentsTabProps) => {
  return (
    <Box sx={{ mt: 2 }}>
      <CustomTable
        title='Voicemail Details by Agent'
        columns={[
          { key: 'agentName', label: 'Agent' },
          { key: 'total', label: 'Total' },
          { key: 'inbound', label: 'Inbound' },
          { key: 'outbound', label: 'Outbound' },
          { key: 'avgDuration', label: 'Avg Duration' },
        ]}
        rows={agents.map((a) => {
          const prevData = findAgentComparison(a.agentId, comparison);

          return {
            agentName: a.agentName || 'Unknown',
            total: formatWithComparisonTwoRows(a.count, prevData?.count),
            inbound: formatWithComparisonTwoRows(a.inboundCount, prevData?.inboundCount),
            outbound: formatWithComparisonTwoRows(a.outboundCount, prevData?.outboundCount),
            avgDuration: formatWithComparisonTwoRows(
              a.averageDuration ? formatDuration(a.averageDuration) : 'N/A',
              prevData?.averageDuration ? formatDuration(prevData.averageDuration) : undefined,
            ),
          };
        })}
        defaultText='No agent data available'
        loading={false}
        exportable={true}
        exportFilename='voicemails-by-agent.csv'
      />
    </Box>
  );
};
